module.exports = __webpack_public_path__ + "static/media/users.bf1f6949.svg";